import React, { useEffect, useMemo, useState } from "react";
import "./Nav.scss";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import LiveTvIcon from "@mui/icons-material/LiveTv";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import NotificationsPanel from "./NotificationsPanel";

function Nav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [navBlack, setNavBlack] = useState(false);
  const [toggleMenu, setToggleMenu] = useState(false);
  const [query, setQuery] = useState("");
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const [unreadNotifications, setUnreadNotifications] = useState(0);

  useEffect(() => {
    const transitionNav = () => {
      setNavBlack(window.scrollY > 24);
    };

    transitionNav();
    document.addEventListener("scroll", transitionNav);
    return () => {
      document.removeEventListener("scroll", transitionNav);
    };
  }, []);

  const links = useMemo(
    () => [
      { to: "/home", label: "Accueil" },
      { to: "/series", label: "Series" },
      { to: "/films", label: "Films" },
      { to: "/documentaires", label: "Docs" },
    ],
    []
  );

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    const trimmed = query.trim();
    navigate(trimmed ? `/search?q=${encodeURIComponent(trimmed)}` : "/search");
    setToggleMenu(false);
  };

  const handleLogout = () => {
    logout();
    navigate("/login");
  };
  
//<LiveTvIcon />

  return (
    <header
      className={`nav ${navBlack || toggleMenu ? "nav--black" : "nav--transparent"} ${
        toggleMenu ? "show" : ""
      }`}
    >
      <div className="nav__content">
        <button className="nav__burger" onClick={() => setToggleMenu((value) => !value)}>
          <MenuIcon />
        </button>

        <Link to="/home" className="nav__brand">
          <img src={`${process.env.PUBLIC_URL}/images/mobing.png`} className="nav__logo" alt="Streamflix" />
        </Link>

        <nav className={`nav__links ${toggleMenu ? "nav__links--open" : ""}`}>
          {links.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`nav__link ${location.pathname === link.to ? "nav__link--active" : ""}`}
              onClick={() => setToggleMenu(false)}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <form className="nav__search" onSubmit={handleSearchSubmit}>
          <SearchIcon />
          <input
            type="search"
            value={query}
            onChange={(event) => setQuery(event.target.value)}
            placeholder="Titres, genres, documentaires..."
            aria-label="Recherche"
          />
        </form>

        <div className="nav__actions">
          <Link
            to="/direct"
            className={`nav__directLive ${
              location.pathname.startsWith("/direct") || location.pathname.startsWith("/live")
                ? "nav__directLive--active"
                : ""
            }`}
            onClick={() => setToggleMenu(false)}
          >
            <span className="nav__livePulse" />
            <span>Direct</span>
          </Link>
          <button className="nav__iconButton" onClick={() => navigate("/search")} aria-label="Rechercher">
            <SearchIcon />
          </button>
          <div className="nav__notifications">
            <button
              className="nav__iconButton nav__notificationButton"
              aria-label="Notifications"
              onClick={() => setNotificationsOpen((value) => !value)}
            >
              <NotificationsNoneIcon />
              {unreadNotifications > 0 ? (
                <span className="nav__notificationBadge">{Math.min(unreadNotifications, 9)}</span>
              ) : null}
            </button>
            <NotificationsPanel
              open={notificationsOpen}
              onClose={() => setNotificationsOpen(false)}
              onUnreadChange={setUnreadNotifications}
            />
          </div>
          <Link to="/dashboard" className="nav__iconButton nav__studio" aria-label="Studio">
            <DashboardOutlinedIcon />
            <span>Studio</span>
          </Link>
          <button className="nav__profile" onClick={handleLogout}>
            <img src={`${process.env.PUBLIC_URL}/images/avatar.png`} className="nav__avatar" alt="Profil" />
            <span>{user?.nom?.split(" ")?.[0] || "Profil"}</span>
            <LogoutOutlinedIcon />
          </button>
        </div>
      </div>
    </header>
  );
}

export default Nav;
